export default "__VITE_ASSET__DfMXoVCV__"